
import { Component, Vue } from "vue-property-decorator";
import DocumentFields from "@/components/DocumentFields.vue";
import DocumentJoin from "@/components/DocumentJoin.vue";
import "@/assets/css/pages/detail.css";

import News from "@/news";
import { Article } from "@/news_articles";

@Component({
  components: { DocumentFields, DocumentJoin },
})
export default class extends Vue {
  articleId: number = 0;
  article: Article | null = null;

  mounted() {
    this.articleId = parseInt(this.$route.params.articleId, 10);
    this.article = News.getById(this.articleId);
  }
}
